<!--APP插件-->
<template>
  <div class="app-plug">
    <!-- <div class="header">
      <div>
        <span>版本列表</span>
        <span>产品开发阶段，只有才名单用户可以更新下载App插件</span>
      </div>
      <el-button type="primary" @click="addFunc">新增插件</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="版本号">
      </el-table-column>
      <el-table-column prop="name" label="创建时间">
      </el-table-column>
      <el-table-column prop="address" label="状态">
      </el-table-column>
      <el-table-column prop="address" label="更新日志">
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <span class="start-test">开始测试</span>
          <el-button type="text" size="small" @click="handleDelete(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
export default {
  name: 'appPlug',
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    }
  }
}
</script>
<style lang="scss" scoped>
.app-plug {
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  .start-test {
    margin-right: 10px;
  }
}
</style>
